<template>
    <div id="app">
        <SideNav v-bind:width="hideSidebar?0:sideNavWidth" @switched="switchNavWidth">
            <slot name="menu"></slot>
        </SideNav>
        <div v-bind:style="{ marginLeft: (hideSidebar?0:sideNavWidth)+ 'px' }">
            <Alert></Alert>
            <div class="d-flex justify-content-center loader" v-if="loading">
                <b-spinner label="Chargement..." variant="primary"></b-spinner>
            </div>
            <slot name="navbar"></slot>
            <div :class="loading ? 'content-disabled' : 'content-enabled'">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
  import SideNav from '@/components/sidenav/SideNav.vue'
  import Alert from '@/components/Alert.vue'
  import {EventBus} from '@/event-bus'


  export default {
    name: 'SideNavLayout',
    components: {
      SideNav,
      Alert
    },
    props: {
      hideSidebar: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        sideNavWidth: 240,
        loading: false
      }
    },
    mounted() {
      EventBus.$on('Axios-loading', (loading) => {
        this.loading = loading;
      });
    },
    methods: {
      switchNavWidth(isfull) {
        if (isfull) {
          this.sideNavWidth = 240
        } else {
          this.sideNavWidth = 60
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .loader {
        position: sticky;
        top: 50%;
        z-index: 10000000;
        height: 0;
    }

    .content-disabled {
        opacity: 0.5;
        pointer-events: none;
    }
</style>

